export const defListFromMarkdown = {
    enter: {
        defList: enterDefList,
        defListTerm: enterDefListTerm,
        defListDescription: enterDefListDescription,
    },
    exit: {
        defList: exitDefList,
        defListTerm: exitDefListTerm,
        defListDescription: exitDefListDescription,
    },
};
function enterDefList(token) {
    this.enter({ type: 'defList', children: [] }, token);
}
function exitDefList(token) {
    this.exit(token);
}
function enterDefListTerm(token) {
    this.enter({ type: 'defListTerm', children: [] }, token);
}
function exitDefListTerm(token) {
    this.exit(token);
}
function enterDefListDescription(token) {
    this.enter({ type: 'defListDescription', spread: Boolean(token._loose), children: [] }, token);
}
function exitDefListDescription(token) {
    this.exit(token);
}
